import JsBarcode from 'jsbarcode'
import cartaoNacionalSaude from '@/assets/outros/cartao-nacional-saude.png'
import moment from 'moment'
import unmask from '@/utils/unmask.js'

export default {
    print(cidadao) {
        const canvas = document.createElement('canvas')

        JsBarcode(canvas, unmask.unMaskCns(cidadao.cns ? cidadao.cns : ''), {
            displayValue: false,
            fontSize: 10,
            format: "CODE39",
            height: 30,
            margin: 0,
            marginBottom: 0,
            marginTop: 0,
            width: 0.8,
        })

        const page = window.open('', Math.random())

        page.document.write(`
            <head>
                <title>Cartão nacional de saúde</title>

                <style>
                    * {
                        font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                        margin: 0;
                        padding: 0;
                    }
                    .container {
                        align-items: center;
                        display: flex;
                        flex-direction: column;
                        heught: 5cm;
                        position: relative;
                        width: 18cm;
                    }
                    #cartao-nacional-saude {
                        heught: 5cm;
                        width: 18cm;
                    }
                    .text-content {
                        background: white;
                        display: flex;
                        flex-direction: column;
                        height: 3.2cm;
                        justify-content: center;
                        position: absolute;
                        right: 1.4cm;
                        text-align: center;
                        top: 1cm;
                        width: 6.4cm;
                    }
                    .text-content h2 {
                        font-size: 14px;
                    }
                    .text-content h3 {
                        font-size: 14px;
                    }
                </style>
            </head>

            <body>
                <div class="container">
                    <img id="cartao-nacional-saude" src="${cartaoNacionalSaude}" />

                    <div class="text-content">
                        <h3>${cidadao.nome}</h3>

                        <p style="margin-top: 10px;">
                            <div style="display: flex; justify-content: space-between; font-size: 10px; margin: 0 5px;">
                                <div><strong>Data Nasc.:</strong> ${moment(cidadao.dataNascimento).format('DD/MM/YYYY')}</div>
                                <div><strong>Sexo:</strong> ${cidadao.sexo.descricao}</div>
                            </div>
                        </p>

                        <p style="margin-top: 10px;">
                            <h2>${unmask.unMaskCns(cidadao.cns ? cidadao.cns : '')}</h2>
                        </p>

                        <p>
                            <div id="barcode"></div>
                        </p>
                    </div>
                </div>
            </body>
        `)

        if (cidadao.cns) {
            page.document.getElementById('barcode').appendChild(canvas)
        }

        page.document.getElementById('cartao-nacional-saude').onload = () => {
            page.print()
            page.close()
        }
    },
}